import { errorManagerInstance } from './errorManager';
export var StorageKey;
(function (StorageKey) {
    // OfflineMode Only
    StorageKey["CURRENT_SENSOR"] = "v2-keepTrack-currentSensor";
    StorageKey["WATCHLIST_LIST"] = "v2-keepTrack-watchlistList";
    // Others
    StorageKey["SETTINGS_MANAGER_COLORS"] = "v2-settingsManager-colors";
    StorageKey["SETTINGS_DOT_COLORS"] = "v2-keepTrack-settings-dotColors";
    StorageKey["IS_ADVICE_ENABLED"] = "v2-isAdviceEnabled";
    StorageKey["LAST_MAP"] = "v2-keepTrack-earthTexture";
    StorageKey["COLOR_SCHEME"] = "v2-keepTrack-colorScheme";
    StorageKey["SETTINGS_DRAW_CAMERA_WIDGET"] = "v2-keepTrack-settings-drawCameraWidget";
    StorageKey["SETTINGS_DRAW_ORBITS"] = "v2-keepTrack-settings-drawOrbits";
    StorageKey["SETTINGS_DRAW_ECF"] = "v2-keepTrack-settings-drawECF";
    StorageKey["SETTINGS_DRAW_IN_COVERAGE_LINES"] = "v2-keepTrack-settings-drawInCoverageLines";
    StorageKey["SETTINGS_DRAW_BLACK_EARTH"] = "v2-keepTrack-settings-drawBlackEarth";
    StorageKey["SETTINGS_DRAW_ATMOSPHERE"] = "v2-keepTrack-settings-drawAtmosphere";
    StorageKey["SETTINGS_DRAW_MILKY_WAY"] = "v2-keepTrack-settings-drawMilkyWay";
    StorageKey["SETTINGS_GRAY_SKYBOX"] = "v2-keepTrack-settings-graySkybox";
    StorageKey["SETTINGS_ECI_ON_HOVER"] = "v2-keepTrack-settings-eciOnHover";
    StorageKey["SETTINGS_HOS"] = "v2-keepTrack-settings-hos";
    StorageKey["SETTINGS_DEMO_MODE"] = "v2-keepTrack-settings-demoMode";
    StorageKey["SETTINGS_SAT_LABEL_MODE"] = "v2-keepTrack-settings-satLabelMode";
    StorageKey["SETTINGS_FREEZE_PROP_RATE_ON_DRAG"] = "v2-keepTrack-settings-freezePropRateOnDrag";
    StorageKey["SETTINGS_DISABLE_TIME_MACHINE_TOASTS"] = "v2-keepTrack-settings-disableTimeMachineToasts";
    StorageKey["SETTINGS_SEARCH_LIMIT"] = "v2-keepTrack-settings-searchLimit";
    StorageKey["SETTINGS_DRAW_TRAILING_ORBITS"] = "v2-keepTrack-settings-drawTrailingOrbits";
    StorageKey["SETTINGS_DRAW_AURORA"] = "v2-keepTrack-settings-drawAurora";
    StorageKey["SETTINGS_DRAW_SUN"] = "v2-keepTrack-settings-drawSun";
    StorageKey["SETTINGS_CONFIDENCE_LEVELS"] = "v2-keepTrack-settings-confidenceLevels";
    StorageKey["SETTINGS_DRAW_COVARIANCE_ELLIPSOID"] = "v2-keepTrack-settings-drawCovarianceEllipsoid";
    StorageKey["GRAPHICS_SETTINGS_GODRAYS_SAMPLES"] = "v2-keepTrack-graphicsSettings-godraysSamples";
    StorageKey["GRAPHICS_SETTINGS_GODRAYS_DECAY"] = "v2-keepTrack-graphicsSettings-godraysDecay";
    StorageKey["GRAPHICS_SETTINGS_GODRAYS_EXPOSURE"] = "v2-keepTrack-graphicsSettings-godraysExposure";
    StorageKey["GRAPHICS_SETTINGS_GODRAYS_DENSITY"] = "v2-keepTrack-graphicsSettings-godraysDensity";
    StorageKey["GRAPHICS_SETTINGS_GODRAYS_WEIGHT"] = "v2-keepTrack-graphicsSettings-godraysWeight";
    StorageKey["GRAPHICS_SETTINGS_GODRAYS_ILLUMINATION_DECAY"] = "v2-keepTrack-graphicsSettings-godraysIlluminationDecay";
    StorageKey["GRAPHICS_SETTINGS_EARTH_DAY_RESOLUTION"] = "v2-keepTrack-graphicsSettings-earthDayResolution";
    StorageKey["GRAPHICS_SETTINGS_EARTH_NIGHT_RESOLUTION"] = "v2-keepTrack-graphicsSettings-earthNightResolution";
    StorageKey["FILTER_SETTINGS_PAYLOADS"] = "v2-filter-settings-payload";
    StorageKey["FILTER_SETTINGS_ROCKET_BODIES"] = "v2-filter-settings-rocket-bodies";
    StorageKey["FILTER_SETTINGS_DEBRIS"] = "v2-filter-settings-debris";
    StorageKey["FILTER_SETTINGS_UNKNOWN_TYPE"] = "v2-filter-settings-unknown-type";
    StorageKey["FILTER_SETTINGS_AGENCIES"] = "v2-filter-settings-agencies";
    StorageKey["FILTER_SETTINGS_VLEO"] = "v2-filter-settings-vleo";
    StorageKey["FILTER_SETTINGS_LEO"] = "v2-filter-settings-leo";
    StorageKey["FILTER_SETTINGS_HEO"] = "v2-filter-settings-heo";
    StorageKey["FILTER_SETTINGS_MEO"] = "v2-filter-settings-meo";
    StorageKey["FILTER_SETTINGS_GEO"] = "v2-filter-settings-geo";
    StorageKey["FILTER_SETTINGS_X_GEO"] = "v2-filter-settings-x-geo";
    StorageKey["FILTER_SETTINGS_VIMPEL"] = "v2-filter-settings-vimpel";
    StorageKey["FILTER_SETTINGS_CELESTRAK"] = "v2-filter-settings-celestrak";
    StorageKey["FILTER_SETTINGS_NOTIONAL"] = "v2-filter-settings-notional";
    StorageKey["FILTER_SETTINGS_UNITED_STATES"] = "v2-filter-settings-united-states";
    StorageKey["FILTER_SETTINGS_UNITED_KINGDOM"] = "v2-filter-settings-united-kingdom";
    StorageKey["FILTER_SETTINGS_FRANCE"] = "v2-filter-settings-france";
    StorageKey["FILTER_SETTINGS_GERMANY"] = "v2-filter-settings-germany";
    StorageKey["FILTER_SETTINGS_JAPAN"] = "v2-filter-settings-japan";
    StorageKey["FILTER_SETTINGS_CHINA"] = "v2-filter-settings-china";
    StorageKey["FILTER_SETTINGS_INDIA"] = "v2-filter-settings-india";
    StorageKey["FILTER_SETTINGS_RUSSIA"] = "v2-filter-settings-russia";
    StorageKey["FILTER_SETTINGS_USSR"] = "v2-filter-settings-ussr";
    StorageKey["FILTER_SETTINGS_SOUTH_KOREA"] = "v2-filter-settings-south-korea";
    StorageKey["FILTER_SETTINGS_AUSTRALIA"] = "v2-filter-settings-australia";
    StorageKey["FILTER_SETTINGS_OTHER_COUNTRIES"] = "v2-filter-settings-other-countries";
    StorageKey["FILTER_SETTINGS_STARLINK"] = "v2-filter-settings-starlink";
    StorageKey["SENSOR_TIMELINE_ENABLED_SENSORS"] = "v2-sensor-timeline-enabled-sensors";
    StorageKey["VERSION"] = "v2-version";
})(StorageKey || (StorageKey = {}));
export class PersistenceManager {
    storage_;
    static instance_;
    constructor() {
        this.storage_ = localStorage;
        this.validateStorage();
        this.verifyStorage();
    }
    get storage() {
        return this.storage_;
    }
    static getInstance() {
        if (!PersistenceManager.instance_) {
            PersistenceManager.instance_ = new PersistenceManager();
        }
        return PersistenceManager.instance_;
    }
    validateStorage() {
        const currentVersion = this.storage_.getItem(StorageKey.VERSION);
        if (typeof currentVersion === 'string' &&
            typeof settingsManager.versionNumber === 'string' &&
            this.compareSemver_(currentVersion, settingsManager.versionNumber) < 0) {
            // Handle version mismatch
            console.warn(`Version mismatch: ${currentVersion} < ${settingsManager.versionNumber}`);
            console.warn('Clearing local storage...');
            // Perform any necessary migration or cleanup
            this.storage_.clear();
        }
        // Save the current version to storage
        this.storage_.setItem(StorageKey.VERSION, settingsManager.versionNumber);
    }
    /**
     * Compares two semantic version strings.
     *
     * Splits each version string by '.' and compares each numeric part sequentially.
     * Returns -1 if `a` is less than `b`, 1 if `a` is greater than `b`, and 0 if they are equal.
     * Handles versions of different lengths by treating missing parts as 0.
     *
     * @param a - The first semantic version string (e.g., "1.2.3").
     * @param b - The second semantic version string (e.g., "1.2.4").
     * @returns A number indicating the comparison result:
     *          -1 if `a` < `b`, 1 if `a` > `b`, 0 if equal.
     */
    compareSemver_(a, b) {
        const pa = a.split('.').map(Number);
        const pb = b.split('.').map(Number);
        for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
            const na = pa[i] || 0;
            const nb = pb[i] || 0;
            if (na < nb) {
                return -1;
            }
            if (na > nb) {
                return 1;
            }
        }
        return 0;
    }
    verifyStorage() {
        for (let i = 0; i < this.storage_.length; i++) {
            const key = this.storage_.key(i);
            if (!Object.values(StorageKey).includes(key)) {
                // Delete any keys that are not in the StorageKey enum
                this.storage_.removeItem(key);
            }
        }
    }
    getItem(key) {
        if (settingsManager.isBlockPersistence) {
            return null;
        }
        PersistenceManager.verifyKey_(key);
        const value = this.storage_.getItem(key);
        if (value === null) {
            return null;
        }
        return value;
    }
    checkIfEnabled(key, fallback) {
        PersistenceManager.verifyKey_(key);
        const value = this.storage_.getItem(key);
        if (value === null) {
            return fallback;
        }
        return value === 'true';
    }
    saveItem(key, value) {
        if (settingsManager.isBlockPersistence) {
            return;
        }
        if (value === null || typeof value === 'undefined') {
            this.removeItem(key);
            return;
        }
        PersistenceManager.verifyKey_(key);
        try {
            this.storage_.setItem(key, value);
        }
        catch {
            errorManagerInstance.debug(`Failed to save to local storage: ${key}=${value}`);
        }
    }
    clear() {
        for (const key of Object.values(StorageKey)) {
            this.storage_.removeItem(key);
        }
    }
    removeItem(key) {
        PersistenceManager.verifyKey_(key);
        this.storage_.removeItem(key);
    }
    static verifyKey_(key) {
        if (!Object.values(StorageKey).includes(key)) {
            throw new Error(`Invalid key: ${key}`);
        }
    }
}
